import React from 'react';
import { Spin } from 'antd';

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-content">
        <Spin size="large" style={{ color: 'white' }}/>
      </div>
    </div>
  );
};

export default Loader;
